module.exports = __webpack_public_path__ + "img/ahk-nigeria-logo@2x.bfc1da17.png";